import { isPlatformBrowser } from '@angular/common';
import { AfterViewInit, Component, Inject, PLATFORM_ID } from '@angular/core';
import { ActivatedRoute } from '@angular/router';
import { first } from 'rxjs/operators';
import { FeatureFlagService } from '../../../core/services/feature-flag.service';

@Component({
    selector: 'app-risk-warning',
    templateUrl: './risk-warning.component.html',
    styleUrls: ['./risk-warning.component.scss'],
    standalone: false
})
export class RiskWarningComponent implements AfterViewInit {
  constructor(
    private route: ActivatedRoute,
    @Inject(PLATFORM_ID) private platform: Object,
    private readonly featureFlagService: FeatureFlagService,
  ) {}

  /**
   * P2P-28 · F0.3 — the Note (P2P) risk section ships dark behind the P2P-29 flag with
   * clearly-marked draft copy, so the page never waits on legal drafting and legal
   * drafting never blocks the page. Nothing P2P is publicly reachable with the flag off.
   */
  get notesEnabled(): boolean {
    return this.featureFlagService.notesEnabled;
  }

  ngAfterViewInit(): void {
    if (isPlatformBrowser(this.platform)) {
      this.route.fragment.pipe(first()).subscribe((fragment) => {
        if (fragment) {
          setTimeout(() => {
            document.getElementById(fragment).scrollIntoView();
          }, 200);
        }
      });
    }
  }
}
